import { EmploymentInvitee } from 'server/shared/models/employmentInvitee';
import { EmploymentInviteeStatusEnum } from 'server/shared/models/employmentInviteeStatusEnum';
import { Invitee } from 'server/shared/models/invitee';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';

export function getJobInviteeStatusAndIcon(invitee: Invitee): {
  requestState: string;
  stateIcon: string;
} {
  let requestState = '';
  let stateIcon = '';

  switch (invitee.status) {
    case InviteeStatusEnum.BOOKED: {
      if (invitee.transferredFrom) {
        stateIcon = 'booked-transferred';
      } else {
        requestState = 'job-confirmed';
        stateIcon = 'star';
      }
      break;
    }
    case InviteeStatusEnum.TRANSFERRED: {
      requestState = 'transferred-cancelled';
      stateIcon = 'transferred-cancelled';
      break;
    }
    case InviteeStatusEnum.AVAILABLE: {
      requestState = 'request-accepted';
      stateIcon = 'check';
      break;
    }
    case InviteeStatusEnum.POSSIBLE_CANDIDATE: {
      requestState = 'request-accepted';
      stateIcon = 'star-check-outline';
      break;
    }
    case InviteeStatusEnum.CANCELED: {
      requestState = 'request-canceled';
      stateIcon = 'star-off';
      break;
    }
    case InviteeStatusEnum.UNAVAILABLE: {
      requestState = 'request-declined';
      stateIcon = 'close';
      break;
    }
    case InviteeStatusEnum.DECLINED: {
      requestState = 'job-declined';
      stateIcon = 'close-circle-outline';
      break;
    }
    case InviteeStatusEnum.WORKING: {
      requestState = 'request-working';
      stateIcon = 'briefcase';
      break;
    }
    case InviteeStatusEnum.PARTIAL_AVAILABLE: {
      requestState = 'request-partially-accepted';
      stateIcon = 'partial-accept';
      break;
    }
    default: {
      requestState = 'request-pending';
      stateIcon = 'clock-outline';
      break;
    }
  }
  return { requestState, stateIcon };
}

export function getEmploymentInviteeStatusAndIcon(invitee: EmploymentInvitee): {
  requestState: string;
  stateIcon: string;
} {
  let requestState = '';
  let stateIcon = '';

  switch (invitee.status) {
    case EmploymentInviteeStatusEnum.BOOKED: {
      requestState = 'job-confirmed';
      stateIcon = 'star';
      break;
    }
    case EmploymentInviteeStatusEnum.AVAILABLE: {
      requestState = 'request-accepted';
      stateIcon = 'check';
      break;
    }
    case EmploymentInviteeStatusEnum.POSSIBLE_CANDIDATE: {
      requestState = 'request-accepted';
      stateIcon = 'star-check-outline';
      break;
    }
    case EmploymentInviteeStatusEnum.CANCELLED: {
      requestState = 'request-canceled';
      stateIcon = 'star-off';
      break;
    }
    case EmploymentInviteeStatusEnum.UNAVAILABLE: {
      requestState = 'request-declined';
      stateIcon = 'close';
      break;
    }
    case EmploymentInviteeStatusEnum.DECLINED: {
      requestState = 'job-declined';
      stateIcon = 'close-circle-outline';
      break;
    }
    default: {
      requestState = 'request-pending';
      stateIcon = 'clock-outline';
      break;
    }
  }
  return { requestState, stateIcon };
}
